var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-gray-100 relative min-h-screen",attrs:{"id":"app"}},[_c('NavBar'),_vm._t("default"),_c('LandingFooter')],2)}
var staticRenderFns = []

export { render, staticRenderFns }